// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import vMediaQuery from 'v-media-query';
import VueCurrencyFilter from 'vue-currency-filter';
import VueAnalytics from 'vue-analytics';

import App from './App'
import router from './router'
import store from './store'

window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');
require('./assets/sass/styles.scss');

/* eslint-disable no-new */
// window.EventBus = new Vue();

window.Vue = Vue;
Vue.use(VeeValidate, {
    errorBagName: 'errors'
});
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(vMediaQuery);
Vue.use(VueCurrencyFilter, {
    symbol: '$ ',
    thousandsSeparator: ',',
    fractionCount: '2',
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: ''
});

/* global IS_PROD_MODE */
if (IS_PROD_MODE) {
    /* global FRS_GA_TRACKING_ID */
    Vue.use(VueAnalytics, {
        id: FRS_GA_TRACKING_ID,
        router,
        autoTracking: {
            pageviewOnLoad: false
        }
    });
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js